import BaseNavItem from "./components/BaseNavItem.jsx";
import NavDropdownComponent from "./components/NavDropdown.jsx";

/**
 * Componente Nav - Container principal para navegação
 *
 * Fornece duas variações:
 * - Nav.Item: Item de navegação convencional
 * - Nav.Dropdown: Dropdown com itens
 */
const Nav = ({ children, className, style }) => {
	return (
		<nav className={className} style={style}>
			{children}
		</nav>
	);
};

/**
 * Nav.Item - Item de navegação convencional
 *
 * Pode funcionar como:
 * - Link simples com callback
 * - Link interno (usa StaticI18nLink)
 * - Link externo
 */
const NavItem = ({
	title,
	onClick,
	href,
	target,
	rel,
	className,
	style,
	isExternal = false,
}) => {
	return (
		<BaseNavItem
			title={title}
			onClick={onClick}
			href={href}
			target={target}
			rel={rel}
			className={className}
			style={style}
			isExternal={isExternal}
		/>
	);
};

/**
 * Nav.Dropdown - Dropdown com itens
 *
 * Renderiza um dropdown com os children como itens
 */
const NavDropdown = ({ title, children, className, style }) => {
	return (
		<NavDropdownComponent title={title} className={className} style={style}>
			{children}
		</NavDropdownComponent>
	);
};

// Adicionando as variações como propriedades estáticas
Nav.Item = NavItem;
Nav.Dropdown = NavDropdown;

export default Nav;
